import { render, staticRenderFns } from "./ListItemSkeleton.vue?vue&type=template&id=24d2ff44&scoped=true&lang=pug&functional=true&"
import script from "./ListItemSkeleton.vue?vue&type=script&lang=js&"
export * from "./ListItemSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ListItemSkeleton.vue?vue&type=style&index=0&id=24d2ff44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "24d2ff44",
  null
  
)

export default component.exports